import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Stats from './stats/Stats';
import { useGetDashboardQuery } from 'service/institutionQuery/institutionQuery';
import DepartmentwiseStats from './departmentwiseStat/DepartmentwiseStats';

function InstitutionDashboard() {
  const { data } = useGetDashboardQuery();
  return (
    <div className="pb-5">
      <Row className="g-4">
        <Col xs={12} xxl={6}>
          <div className="mb-8">
            <h2 className="mb-2">Institution Dashboard</h2>
            <h5 className="text-body-tertiary fw-semibold">
              Efficiently manage your students and streamline the recruitment
              process by <br /> uploading student profiles, tracking skills, and
              connecting with recruiters for skill-based hiring
            </h5>
          </div>
          <Stats statsDetails={data} />
          <hr className="bg-body-secondary mb-6 mt-4" />
          <DepartmentwiseStats />
        </Col>
      </Row>
    </div>
  );
}

export default InstitutionDashboard;
